export const TENNIS_MODULE_NAME = 'tennis';
export const TENNIS_MODULE_PATH = '/tennis/';




// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/tennis/constants/identifiers.js